module.exports = __webpack_public_path__ + "912ec66d7572ff821749319396470bde.svg";


//////////////////
// WEBPACK FOOTER
// ./~/vue-blu/dist/img/fontawesome-webfont.svg
// module id = 255
// module chunks = 21